module.exports = __webpack_public_path__ + "img/nogo-koenen-min.ece32dbe.jpg";